import React, { useEffect, useState } from "react";
import { Table, Button, Input, Select, message, Card, Radio, DatePicker } from "antd";
import api from '../../../api/axios';
import dayjs from 'dayjs';

const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

const smsTemplates = {
  // --- Muslim Holidays ---
  muslimRamadan:
    "JS Construction Machinery and Spareparts wishes you a blessed Ramadan! May your fasting and prayers be accepted and bring you peace and prosperity.",
  muslimEidAlFitr:
    "JS Construction Machinery and Spareparts wishes you a joyous Eid al-Fitr! May this day bring happiness, forgiveness, and prosperity to you and your family.",
  muslimEidAlAdha:
    "JS Construction Machinery and Spareparts wishes you a blessed Eid al-Adha! May your sacrifices bring joy, peace, and blessings to you and your loved ones.",
  
  // --- Ethiopian Orthodox Holidays ---
  orthodoxTimkat:
    "JS Construction Machinery and Spareparts wishes you a Happy Timkat! May the blessings of Epiphany fill your home with joy and peace.",
  orthodoxFasika:
    "JS Construction Machinery and Spareparts wishes you a joyful Fasika (Easter)! May your heart be filled with hope and renewal.",
  orthodoxMeskel:
    "JS Construction Machinery and Spareparts wishes you a blessed Meskel! May the celebration of the True Cross bring happiness and prosperity to your family.",
  orthodoxNewYear:
    "JS Construction Machinery and Spareparts wishes you a Happy Ethiopian Orthodox New Year! Melkam Addis Amet!",
  orthodoxGenna:
    "JS Construction Machinery and Spareparts wishes you a Merry Ethiopian Christmas (Genna)! May peace and joy be with you and your family.",

  // --- General / Other Holidays ---
  holiday:
    "JS Construction Machinery and Spareparts wishes you a joyful Ethiopian holiday. Thank you for being our valued customer!"
};


const CustomerNotification = () => {
  const [customers, setCustomers] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [smsText, setSmsText] = useState("");
  const [filter, setFilter] = useState("all");
  const [dateRange, setDateRange] = useState(null);
const [searchText, setSearchText] = useState("");
const [editingId, setEditingId] = useState(null);
const [tempPhone, setTempPhone] = useState("");
  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async (filterType = "all", range = null) => {
    try {
      let url = "/api/customer-reports/customers";

      // Add query params for active filter if needed
      if (filterType === "active" && range) {
        const start = range[0].toISOString();
        const end = range[1].toISOString();
        url += `?startDate=${start}&endDate=${end}`;
      }

      const res = await api.get(url);

      setCustomers(res.data);
    } catch (err) {
      message.error("Failed to load customers");
    }
  };
const filteredCustomers = customers.filter(c =>
  c.name?.toLowerCase().includes(searchText.toLowerCase())
);
  const handleTemplateChange = (value) => {
    setSmsText(smsTemplates[value]);
  };

const handlePhoneChange = (id, value) => {
  let phone = value;

  // enforce Ethiopian format
  if (phone && !phone.startsWith("251")) {
    phone = "251" + phone.replace(/^0+/, "");
  }

  setCustomers(prev =>
    prev.map(c => (c.id === id ? { ...c, phone } : c))
  );

  // auto-save only if valid length
  if (phone && phone.length >= 9) {
    updateCustomerPhone(id, phone);
  }
};
const startEditPhone = (record) => {
  setEditingId(record.id);
  setTempPhone(record.phone || "");
};
const cancelEdit = () => {
  setEditingId(null);
  setTempPhone("");
};
const savePhone = async (id) => {
  let phone = tempPhone;

  // ensure prefix
  if (!phone.startsWith("251")) {
    phone = "251" + phone.replace(/^0+/, "");
  }

  // must be exactly 12 digits (251 + 9 digits)
  const isValid = /^251\d{9}$/.test(phone);

  if (!isValid) {
    return message.error("Phone must start with 251 and be 12 digits total");
  }

  try {
    await updateCustomerPhone(id, phone);

    setCustomers(prev =>
      prev.map(c => (c.id === id ? { ...c, phone } : c))
    );

    message.success("Phone updated");
    cancelEdit();
  } catch (err) {
    message.error("Update failed");
  }
};
  const sendBulkSMS = async (sendAll = false, scheduleDate = null) => {
    let targetCustomers = sendAll ? customers : customers.filter((c) =>
      selectedRowKeys.includes(c.id)
    );

    const phones = targetCustomers
      .map((c) => c.phone)
      .filter((p) => p && p.length >= 3); // basic validation

    if (!phones.length) {
      return message.warning("No valid phone numbers available to send SMS");
    }

    try {
      await api.post("/api/customer-reports/send-bulk", {
        phones,
        message: smsText,
        schedule: scheduleDate ? scheduleDate.toISOString() : null
      });

      message.success("SMS sent successfully!");
      setSelectedRowKeys([]);
    } catch (error) {
      message.error("Failed to send SMS");
    }
  };

  const columns = [
    { title: "Customer Name", dataIndex: "name" },
   {
  title: "Phone",
  dataIndex: "phone",
  render: (text, record) => (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      
      {editingId === record.id ? (
        <>
          <Input
            value={tempPhone}
            onChange={(e) => setTempPhone(e.target.value)}
            placeholder="2519XXXXXXXX"
            style={{ width: 160 }}
          />

          <Button
            type="primary"
            size="small"
            onClick={() => savePhone(record.id)}
          >
            Save
          </Button>

          <Button
            size="small"
            onClick={cancelEdit}
          >
            Cancel
          </Button>
        </>
      ) : (
        <>
          <span>{text || "No phone"}</span>

          <Button
            type="link"
            onClick={() => startEditPhone(record)}
          >
            ✏️
          </Button>
        </>
      )}
    </div>
  )
},
    { title: "Total Purchases", dataIndex: "totalPurchases", render: (val) => val || 0 }
  ];
const updateCustomerPhone = async (id, phone) => {
  try {
    await api.put(`/api/customer-reports/customers/${id}/phone`, {
      phone
    });
  } catch (err) {
    message.error("Failed to update phone");
  }
};
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys)
  };

  return (
    <Card title="Customer SMS Notification">
     
  <Select
  placeholder="Select SMS Template"
  style={{ width: 300, marginBottom: 20 }}
  onChange={handleTemplateChange}
>
  {/* Muslim Holidays */}
  <Option value="muslimRamadan">Ramadan</Option>
  <Option value="muslimEidAlFitr">Eid al-Fitr</Option>
  <Option value="muslimEidAlAdha">Eid al-Adha</Option>

  {/* Orthodox Holidays */}
  <Option value="orthodoxTimkat">Timkat</Option>
  <Option value="orthodoxFasika">Fasika (Easter)</Option>
  <Option value="orthodoxMeskel">Meskel</Option>
  <Option value="orthodoxNewYear">Ethiopian Orthodox New Year</Option>
  <Option value="orthodoxGenna">Genna (Christmas)</Option>

  {/* General */}
  <Option value="holiday">General Holiday</Option>
</Select>

      <TextArea
        rows={4}
        value={smsText}
        onChange={(e) => setSmsText(e.target.value)}
        placeholder="Draft SMS Message"
        style={{ marginBottom: 20 }}
      />

      <div style={{ marginBottom: 20 }}>
        <Radio.Group
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{ marginRight: 20 }}
        >
          <Radio.Button value="all">All Customers</Radio.Button>
          <Radio.Button value="active">Active Customers</Radio.Button>
        </Radio.Group>

        {filter === "active" && (
          <RangePicker
            onChange={(dates) => setDateRange(dates ? [dates[0], dates[1]] : null)}
          />
        )}

        <Button
          type="default"
          onClick={() => fetchCustomers(filter, dateRange)}
          style={{ marginLeft: 20 }}
        >
          Apply Filter
        </Button>
      </div>
<Input
  placeholder="Search customer by name..."
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
  style={{ width: 300, marginBottom: 15 }}
/>
      <Table
        rowKey="id"
        rowSelection={rowSelection}
        columns={columns}
        dataSource={filteredCustomers}
        pagination={{ pageSize: 5 }}
      />

      <div style={{ marginTop: 20 }}>
        <Button
          type="primary"
          onClick={() => sendBulkSMS(false)}
          style={{ marginRight: 10 }}
        >
          Send SMS to Selected
        </Button>

        <Button
          type="default"
          onClick={() => sendBulkSMS(true)}
          style={{ marginRight: 10 }}
        >
          Send SMS to ALL
        </Button>

        <DatePicker
          showTime
          placeholder="Schedule SMS"
          onChange={(value) => {
            if (value) {
              sendBulkSMS(true, value);
            }
          }}
        />
      </div>
    </Card>
  );
};

export default CustomerNotification;